// @ts-nocheck - The styled Badge component only accepts a string as children

import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';

import { Badge } from '@vimeo/iris/components';
import { CircleFilled } from '@vimeo/iris/icons';

import { LiveStatus } from '../../types';

type Props = {
  status: LiveStatus | string | undefined;
};

const LiveBadge = ({ status }: Props) => {
  if (status === 'streaming') {
    return (
      <FeaturedBadge format="live" label="Live Event">
        <RecordIcon /> Live Event
      </FeaturedBadge>
    );
  }

  return (
    <OffAirBadge format="info" label="Offline">
      <RecordIcon /> Offline
    </OffAirBadge>
  );
};

export default LiveBadge;

const RecordIcon = styled(CircleFilled)`
  width: ${rem(7)};
  height: ${rem(7)};
  circle {
    fill: white;
  }
`;

const FeaturedBadge = styled(Badge)`
  pointer-events: none;
  margin: 0 auto ${rem(25)};
  font-size: ${rem(12)};
  text-align: center;
`;

const OffAirBadge = styled(FeaturedBadge)`
  background-color: rgba(0, 0, 0, 0.25);
  color: white;
  text-transform: uppercase;
`;
